import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const CheckIcon: React.FC<IconProps> = props => (
  <Icon fill="currentColor" {...props}>
    <path d="M9.55001 18L3.85001 12.3L5.27501 10.875L9.55001 15.15L18.725 5.975L20.15 7.4L9.55001 18Z" />
  </Icon>
)
